import {
  Card,
  Divider,
  Icon,
  TextButton,
  typography,
} from '@joor/design-system'
import styled from 'styled-components/macro'

export const StyledCard = styled(Card)`
  section {
    padding: 18px 12px 8px 12px;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const ConceptsContainer = styled.div`
  padding: 0 4px;
  & > *:not(:first-child) {
    margin-bottom: 8px;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.total {
    background-color: var(--color-primary-100);
    border-radius: 3px;
    margin-bottom: 0;
    padding: 8px;
  }
`

export const ConceptText = styled.p`
  margin-bottom: 0 !important;
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-800);
  display: flex;
  align-items: center;
  gap: 3px;
  display: flex;
  align-items: center;

  &.light {
    color: var(--color-primary-500);
  }

  &.disabled {
    color: var(--color-primary-300);
  }

  &.small {
    font-size: 10px;
  }

  &.padding-top {
    padding-top: 8px;
  }
`

export const NumericText = styled.p`
  ${typography.numeric.primaryActive.body3}
  text-align: end;

  &.red {
    color: var(--color-error-700);
  }

  &.green {
    color: var(--color-success-500);
  }
`

export const EditModeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  hr {
    width: 100%;
    border: 0.5px solid var(--color-primary-200);
  }
`

export const StyledDivider = styled(Divider)`
  > div {
    margin-left: 0;
    margin-right: 0;
  }
`

export const StyledIcon = styled(Icon)`
  svg {
    --main-color: var(--color-secondary-800);
  }
`

export const CustomFeeWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:first-child) :not(:nth-child(2)) {
    margin-top: 8px;
  }
`

export const DeleteButton = styled(TextButton)`
  align-self: end;
`
